(ns ballot-scout-v2-frontend.layout.sidebar.views.jurisdiction-switcher
  (:require
   [ballot-scout-v2-frontend.components.click-outside :refer [click-outside]]
   [ballot-scout-v2-frontend.components.icon :refer [icon] :as icon]
   [ballot-scout-v2-frontend.components.link :refer [link]]
   [ballot-scout-v2-frontend.subs :as subs]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(defn election-slug-from-j [j]
  (-> j :jurisdiction/current-election :election/slug))

(defn partner-link [partner]
  (let [current-partner @(rf/subscribe [::subs/current-partner])
        selected? (and @(rf/subscribe [::subs/on-partner-admin-page?])
                       (= (:partner/id current-partner) (:partner/id partner)))]
    [link
     {:route-name :ballot-scout-v2-frontend.routes/partner-home
      :params {:partner-slug @(rf/subscribe [::subs/current-partner-slug])
               :election-slug @(rf/subscribe [::subs/current-election-slug])}}
     (if selected?
       [:tr.navbar-item.selected
        [:td [icon ::icon/check {:class "is-hidden-mobile"}]]
        [:td (:partner/name partner)]]
       [:tr.navbar-item [:td] [:td (:partner/name partner)]])]))

(defn jurisdiction-link [jurisdiction]
  (let [current-jurisdiction @(rf/subscribe [::subs/current-jurisdiction])
        selected? (and (not @(rf/subscribe [::subs/on-partner-admin-page?]))
                       (= (:jurisdiction/id current-jurisdiction) (:jurisdiction/id jurisdiction)))]
    [link
     {:route-name :ballot-scout-v2-frontend.routes/jurisdiction-home
      :params {:partner-slug @(rf/subscribe [::subs/current-partner-slug])
               :election-slug (election-slug-from-j jurisdiction)
               :jurisdiction-slug (:jurisdiction/slug jurisdiction)}}
     (if selected?
       [:tr.navbar-item.selected
        [:td [icon ::icon/check {:class "is-hidden-mobile"}]]
        [:td (:jurisdiction/name jurisdiction)]]
       [:tr.navbar-item [:td] [:td (:jurisdiction/name jurisdiction)]])]))

(defn valid-jurisdiction?
  "Jurisdiction is valid if it has a slug and has a current election with a slug"
  [j]
  (and (:jurisdiction/slug j)
       (election-slug-from-j j)))

#_:clj-kondo/ignore
(defn dropdown [current-partner current-jurisdiction jurisdictions]
  (let [active? (r/atom false)]
    (fn [current-partner current-jurisdiction jurisdictions]
      [click-outside
       {:on-click-outside #(reset! active? false)}
       (fn [ref]
         [:a {:ref ref :on-click #(swap! active? not)}
          [:div.switcher.navbar-item.has-dropdown {:class (when @active? "is-active")}
           [:div.dropdown-text
            [:div.text
             (if @(rf/subscribe [::subs/on-partner-admin-page?])
               (:partner/name current-partner)
               (:jurisdiction/name current-jurisdiction))]
            (if @active? [icon ::icon/chevron-up] [icon ::icon/chevron-down])]
           (when @active?
             [:div.navbar-dropdown
              [:table
               (into [:<>]
                     (concat
                      (when @(rf/subscribe [::subs/partner-admin?])
                        [[partner-link current-partner]
                         [:hr.navbar-divider]])
                      (for [j jurisdictions]
                        ^{:key (str (:jurisdiction/slug j) "_link")} [jurisdiction-link j])))]])]])])))

(defn component []
  (let [current-partner @(rf/subscribe [::subs/current-partner])
        jurisdictions (->> current-partner
                           :partner/jurisdictions
                           (filter valid-jurisdiction?)
                           (sort-by :jurisdiction/name))
        current-jurisdiction @(rf/subscribe [::subs/current-jurisdiction])]
    (cond
      (empty? jurisdictions)
      [:small.switcher.dropdown-text [:div.text "Loading..."]]

      (= 1 (count jurisdictions))
      [:div.switcher.dropdown-text.is-hidden-mobile
       [:div.text (-> jurisdictions first :jurisdiction/name)]]

      :else
      [dropdown current-partner current-jurisdiction jurisdictions])))
